import cyberSecurityData from '../apis/cyberSecurityData';
import history from '../history'; // to be able to make programatic navs
import { changeSortOptions, changeSortBy, changeSortOrder } from './sortActions';
import { getSortOptions } from '../configs/dropdownOptions';

export const fetchItems = (data) => async (dispatch, getState) => {
    window.scrollTo({
        top: 0,
        // behavior: "smooth"
    });

    dispatch({ type: 'RESET_PAGE' });
    dispatch({ type: 'FETCH_ITEMS', payload: data })
}

export const loadMore = (data) => async (dispatch, getState) => {
    dispatch({ type: 'LOAD_MORE', payload: data })
}

export const exactMatchToggle = (state) => {
    return {
        type: 'CHANGE_EXACT_MATCH',
        payload: state
    }
}

export const incrementViewsCount = (itemId, page, item) => async (dispatch, getState) => {
    const data = { itemId, page, item };
    if (getState().currentUser._id) data.userId = getState().currentUser._id
    else data.uniqueId = getState().uniqueId;

    const response = await cyberSecurityData.post('/addview', data);

    dispatch({ type: 'INCREMENT_VIEWS_COUNT', payload: response.data })
    return response.data
}

export const addFilter = (key, value) => async (dispatch, getState) => {
    dispatch({ type: 'RESET_PAGE' });

    if (key === 'mainCategory') {
        if (value === 'Breaches') {
            dispatch(updateTopFilters('Stories'));
            dispatch(fetchSideList(TopFiltersData['Stories'].active, 'Stories'));

            //when changing the main category the sort options will be updated based on the selected category
            dispatch(changeSortOptions(getSortOptions('Stories'))); //updating the options
            dispatch(changeSortOrder(-1)); //updating the order to be descending by default
        } else {
            dispatch(updateTopFilters(value));
            dispatch(fetchSideList(TopFiltersData[value].active, value));

            //when changing the main category the sort options will be updated based on the selected category
            dispatch(changeSortOptions(getSortOptions(value))); //updating the options
            dispatch(changeSortOrder(-1)); //updating the order to be descending by default
        }
    }

    if (key === 'search') {

        // sort option = ['Best Match', 'Newest', ....] so first option (index 0) is Best Match and second option (index 1) is Newest
        //so checking if the current category is Stories that will make the defualt sort option is 1 (Newest) else will be 0 (Best Match)
        let optionIndex;
        if (getState().filters.mainCategory === 'Stories') optionIndex = 1;
        else optionIndex = 0;

        dispatch(changeSortBy(getState().sortOptions[optionIndex]));

    } else dispatch(changeSortBy(getState().sortOptions[1]));

    if (key === 'Breach Date') {
        dispatch(changeSortBy('Breaches Count'));
        dispatch(changeSortOptions(['Best Match', 'Breaches Count', 'Latest Breach', 'Trukno Pick', 'Related Breaches', 'Related Stories', 'Related Actors', 'Related Solutions', 'Related Companies', 'Related Experts', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date']));
    }

    dispatch({
        type: 'ADD_FILTER',
        payload: { key, value }
    })
}

export const removeFilter = (key) => async (dispatch, getState) => {
    dispatch({
        type: 'REMOVE_FILTER',
        payload: { key }
    })

    if (key === 'search') {
        dispatch(changeSortBy(getState().sortOptions[1]));

        //when clearing the search filter, the catgory might be changed to Breaches by search count buttons, so in that case we need to change the category back to Stories
        if (getState().filters.mainCategory === 'Breaches') dispatch(addFilter('mainCategory', 'Stories'))
    }
}

export const resetFilters = () => async (dispatch, getState) => {

    dispatch({
        type: 'RESET_FILTER',
    })
}

export const nextPage = () => {
    return {
        type: 'NEXT_PAGE'
    }
}

export const resetPage = () => {
    return {
        type: 'RESET_PAGE'
    }
}

export const updateTopFilters = (category) => {
    let list = TopFiltersData[category].list;
    let activeTopFilter = TopFiltersData[category].active;
    return {
        type: 'UPDATE_TOP_FILTERS',
        payload: {
            list, activeTopFilter
        }
    }
}

export const updateActiveTopFilter = (active) => {
    return {
        type: 'UPDATE_ACTIVE_TOP_FILTERS',
        payload: active
    }
}

export const fetchSideList = (activeFilter, category) => async (dispatch, getState) => {
    const response = await cyberSecurityData.get('/cyberaggregate', {
        params: {
            activeFilter, category
        },
        headers: {
            Authorization: 'Bearer ' + getState().accessToken
        }

    })

    dispatch({
        type: 'FETCH_SIDE_LIST',
        payload: response.data
    })
}

//Action that closes the modal (setting the modalVisible to false)
export const setModalView = (view) => {
    return {
        type: 'SET_MODAL_VIEW',
        payload: view
    }
}

//action to toggle the visibilty of the search bar
export const toggleSearch = () => (dispatch, getState) => {

    if (getState().searchVisible) {
        return dispatch({
            type: 'TOGGLE_SEARCH',
            payload: false
        })
    }

    return dispatch({
        type: 'TOGGLE_SEARCH',
        payload: true
    })
}

//Configurations
let TopFiltersData = {
    Stories: {
        // list: ['Story Type', 'Top Websites', 'Top Authers', 'Industry', 'Author Type', 'Date'],
        list: ['Top Websites', 'Story Type', 'Industry', 'Date'],
        active: 'Top Websites'
    },
    Actors: {
        list: ['Location', 'Sub Category', 'Industry'],
        active: 'Location'
    },
    Threats: {
        list: ['Sub Category', 'Breach Date', 'Threat Type', 'Attack Stage', 'Industry'],
        active: 'Sub Category'
    },
    Solutions: {
        list: ['Sub Category', 'Solution Type', 'Industry'],
        active: 'Sub Category'
    },
    Companies: {
        // list: ['Sub Category', 'Product Type', 'Industry', 'HQ Location'],
        list: ['Sub Category', 'Industry'],
        active: 'Sub Category'
    },
    Experts: {
        list: ['Location', 'Job Role', 'Industry', 'Collaboration'],
        active: 'Location'
    }
};
